import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import "./index.css";
import { Col, Row, Stack } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import {
  onChangeToNumber,
  validateEmail,
} from "../../../../utils/helperFunction";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchCategoryClassificationData,
  fetchUsers,
  setFormDataQuickReport,
} from "../../../../redux/slice/QuickReportSlice";
import { NavLink, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import SelectWithTextfield from "../../../../components/Common/MUI/SelectWithTextfield";

const OnlineQuickPageOne = () => {
  const dispatch = useDispatch();
  const [category_classficationdata, setCategory_classficationdata] = useState({
    category: [],
    classfication: [],
  });
  const {
    category_classfication_data,
    form_Data,
    usersList,
    injuryType,
    quichReportData,
  } = useSelector((state) => state.QUICKREPORT);
  const [users, setUsers] = useState([]);
  const [formData, setFormData] = useState(form_Data);
  const navigate = useNavigate();

  // main state for the form data
  const today = new Date().toISOString().split("T")[0];
  const getCurrentTime = () => {
    const now = new Date();
    let hours = now.getHours();
    let minutes = now.getMinutes();

    // Add leading zero for single digit hours and minutes
    if (hours < 10) hours = `0${hours}`;
    if (minutes < 10) minutes = `0${minutes}`;

    return `${hours}:${minutes}`;
  };

  const currentTime = getCurrentTime();

  //onchange function to manipulate the state of the form data on change of input field
  //@@parm is event

  const onChange = (event) => {
    const { name, value } = event.target;
    if (name === "date") {
      const selectedDate = new Date(value);
      const maxDate = new Date(today);
      selectedDate.setHours(0, 0, 0, 0);
      maxDate.setHours(0, 0, 0, 0);
      if (selectedDate > maxDate) {
        toast.error("Toady is maximum date");
      }
      setFormData((prev) => ({
        ...prev,
        date: {
          value: selectedDate > maxDate ? today : value,
          warning: !value ? true : false,
        },
      }));
    } else if (name === "time") {
      // Convert selected time and current time into minutes from midnight
      const getTimeInMinutes = (time) => {
        const [hours, minutes] = time.split(":").map(Number);
        return hours * 60 + minutes; // Convert time to minutes from midnight
      };

      const selectedTimeInMinutes = getTimeInMinutes(value);
      const currentTimeInMinutes = getTimeInMinutes(currentTime);

      if (selectedTimeInMinutes > currentTimeInMinutes) {
        toast.error("Current time is maximum time");
      }

      setFormData((prev) => ({
        ...prev,
        time: {
          value:
            selectedTimeInMinutes > currentTimeInMinutes ? currentTime : value,
          warning: !value ? true : false,
        },
      }));
    } else {
      if (name === "category") {
        const filterarray = category_classfication_data?.data?.Incidents?.find(
          (curElm) => curElm.name === value
        );
        setCategory_classficationdata({
          ...category_classficationdata,
          classfication: filterarray?.description,
        });
      }
      setFormData((prev) => ({
        ...prev,
        [name]: { value: value, warning: !value ? true : false },
      }));
    }
  };

  // validate the form on submit
  const validateForm = (event) => {
    event.preventDefault();
    let data = { ...formData };
    data = {
      ...data,
      firstName: { ...data.firstName, warning: !data.firstName.value },
      lastName: { ...data.lastName, warning: !data.lastName.value },
      phoneNumberCode: {
        ...data.phoneNumberCode,
        warning: !data.phoneNumberCode.value,
      },
      phoneNumber: { ...data.phoneNumber, warning: !data.phoneNumber.value },
      category: {
        ...data.category,
        warning:
          !data.category.value ||
          data.category.value === "Category of Incident",
      },
      email: { ...data.email, warning: validateEmail(data.email.value) },
      classification: {
        ...data.classification,
        warning:
          !data.classification.value ||
          data.classification.value === "Classification",
      },
      date: { ...data.date, warning: !data.date.value },
      time: { ...data.time, warning: !data.time.value },
      ...(injuryType === "single" && {
        personOfTreatment: {
          ...data.personOfTreatment,
          warning: !data.personOfTreatment.value,
        },
      }),
    };
    setFormData({ ...data });
    if (
      !data.firstName.warning &&
      !data.lastName.warning &&
      !data.email.warning &&
      !data.category.warning &&
      !data.classification.warning &&
      !data.time.warning &&
      !data.date.warning &&
      (injuryType === "single" ? !data.personOfTreatment.warning : true)
    ) {
      dispatch(setFormDataQuickReport(data)); // dispatch the data of form in the redux store to get them in summary route

      navigate("/quickreportworkplace");
    }
  };

  useEffect(() => {
    // get the data from the backend classfication category
    dispatch(fetchCategoryClassificationData());
    const selectedDate = formData?.date?.value;
    const selectedTime = formData.time.value;
    if (!selectedDate) {
      setFormData((prev) => ({
        ...prev,
        date: { value: today, warning: false },
      }));
    }
    if (!selectedTime) {
      setFormData((prev) => ({
        ...prev,
        time: { value: currentTime, warning: false },
      }));
    }
    const forDetails = {
      ...form_Data,
    };
    setFormData((prev) => ({
      ...prev,
    }));
    dispatch(setFormDataQuickReport(forDetails));
  }, []);

  //manipulate the backend data as per the frontend
  useEffect(() => {
    const data = {
      category: category_classfication_data?.data?.Incidents?.map(
        (itemIncdients) => {
          return itemIncdients.name;
        }
      ),
      classfication: (
        category_classfication_data?.data?.Incidents?.[0]?.description ?? []
      )?.map((element) => {
        return element;
      }),
    };
    setCategory_classficationdata(data);
  }, [category_classfication_data?.data?.Incidents]);

  useEffect(() => {
    dispatch(fetchUsers(quichReportData?.kit_data?.company_id));
  }, []);

  useEffect(() => {
    const formattedList = usersList.map((user) => {
      return `${user.first_name} ${user.last_name}`;
    });
    setUsers(formattedList);
  }, [usersList]);

  return (
    <Form className="quickonepage flex-grow-1 d-flex flex-column justify-content-between">
      <div className="incident-report-container d-flex flex-column row-gap-3">
        <div className="provideinformation">
          <h6 className="fw-bold mb-3 text-center">Confirm your details</h6>
          <Row className="row-gap-3 gx-3">
            <Col xs={6}>
              <Form.Group controlId="formBasicName">
                <Form.Label className="d-none"></Form.Label>
                <Form.Control
                  name={"firstName"}
                  value={formData.firstName.value}
                  type="text"
                  placeholder="First name"
                  onChange={onChange}
                />
                {formData.firstName.warning ? (
                  <p className="text-danger mt-1 mb-0">Enter first name</p>
                ) : null}
              </Form.Group>
            </Col>
            <Col xs={6}>
              <Form.Group controlId="formBasic1Name">
                <Form.Label className="d-none"></Form.Label>
                <Form.Control
                  name={"lastName"}
                  value={formData.lastName.value}
                  type="text"
                  placeholder="Last name"
                  onChange={onChange}
                />
                {formData.lastName.warning ? (
                  <p className="text-danger mt-1 mb-0">Enter last name</p>
                ) : null}
              </Form.Group>
            </Col>
            <Form.Group className="col-12" controlId="formBasicBusinessName">
              <div className="phn_input">
                <div className="phone-input">
                  <PhoneInput
                    name="phoneNumberCode"
                    country={"gb"}
                    disableTyping={true}
                    inputProps={{
                      readOnly: true,
                    }}
                    value={formData.phoneNumberCode.value}
                    onChange={(value) =>
                      onChange({
                        target: {
                          name: "phoneNumberCode",
                          value: `+${value}`,
                        },
                      })
                    }
                  />
                </div>
                <Form.Control
                  onKeyPress={(e) => {
                    if (
                      e.key === "e" ||
                      e.key === "E" ||
                      isNaN(Number(e.key))
                    ) {
                      e.preventDefault();
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === " ") {
                      e.preventDefault();
                    }
                  }}
                  name="phoneNumber"
                  type="text"
                  pattern="[0-9]*"
                  value={onChangeToNumber(formData.phoneNumber.value)}
                  onChange={onChange}
                  placeholder="Number"
                />
              </div>
              {/* {(formData.phoneNumberCode.warning ||
                formData.phoneNumber.warning) && (
                <Stack direction="horizontal" gap={2}>
                  {formData.phoneNumberCode.warning && (
                    <p className="text-danger mt-1 mb-0">Enter phone code</p>
                  )}
                  {formData.phoneNumber.warning && (
                    <p className="text-danger mt-1 mb-0">Enter phone number</p>
                  )}
                </Stack>
              )} */}
            </Form.Group>
            <Col xs={12}>
              <Form.Group controlId="formBasicEmail">
                <Form.Label className="d-none"></Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Email"
                  value={formData.email.value}
                  name={"email"}
                  onChange={onChange}
                />
                {formData.email.warning ? (
                  <p className="text-danger mt-1 mb-0">Enter valid email</p>
                ) : null}
              </Form.Group>
            </Col>
          </Row>
        </div>
        <hr className="my-1" />
        <div>
          <h6 className="fw-bold mb-3 text-center">
            Please provide a summary of incident
          </h6>
          <Row className="row-gap-3 gx-3">
            <Col xs={12}>
              <Form.Group controlId="formBasicEmail">
                <Form.Select
                  aria-label="Default select example"
                  name={"category"}
                  value={formData.category.value}
                  onChange={onChange}
                >
                  <option value="" disabled className="option-title">
                    Category of Incident
                  </option>
                  {category_classficationdata?.category?.map(
                    (categoryItem, key) => (
                      <option value={categoryItem} key={key}>
                        {categoryItem}
                      </option>
                    )
                  )}
                </Form.Select>
                {formData.category.warning && (
                  <p className="text-danger mt-1 mb-0">Select category</p>
                )}
              </Form.Group>
            </Col>
            {injuryType === "single" && (
              <Col xs={12}>
                <SelectWithTextfield
                  value={formData.personOfTreatment.value ?? ""}
                  onValueChange={(value) =>
                    setFormData((prev) => ({
                      ...prev,
                      personOfTreatment: {
                        value,
                        warning: !value ? true : false,
                      },
                    }))
                  }
                  textProps={{
                    placeholder: "Person of treatment",
                    variant: "outlined",
                    name: "personOfTreatment",
                  }}
                  autoCompleteProps={{ disableClearable: true }}
                  options={users ?? []}
                />
                {formData.personOfTreatment.warning && (
                  <p className="text-danger mt-1 mb-0">
                    Select or Type person of treatment
                  </p>
                )}
              </Col>
            )}
            <Col xs={12}>
              <Form.Group controlId="formBasicEmail">
                <Form.Select
                  name="classification"
                  aria-label="Default select example"
                  value={formData.classification.value}
                  onChange={onChange}
                >
                  <option value="" disabled className="option-title">
                    Classification
                  </option>
                  {category_classficationdata?.classfication?.map(
                    (descriptionItem, key) => (
                      <option value={descriptionItem} key={key}>
                        {descriptionItem}
                      </option>
                    )
                  )}
                </Form.Select>
                {formData.classification.warning && (
                  <p className="text-danger mt-1 mb-0">Select classification</p>
                )}
              </Form.Group>
            </Col>
            <Col xs={6}>
              <Form.Group controlId="formBasicEmail">
                <Form.Control
                  name="date"
                  type="date"
                  value={formData.date.value}
                  onChange={onChange}
                  max={today}
                />
                {formData.date.warning ? (
                  <p className="text-danger mt-1 mb-0">Enter date</p>
                ) : null}
              </Form.Group>
            </Col>
            <Col xs={6}>
              <Form.Group controlId="formBasicEmail">
                <Form.Control
                  name="time"
                  type="time"
                  value={formData.time.value}
                  max={currentTime}
                  onChange={onChange}
                />
                {formData.time.warning ? (
                  <p className="text-danger mt-1 mb-0">Enter time</p>
                ) : null}
              </Form.Group>
            </Col>
            <Col xs={12}>
              <Form.Group controlId="formBasicEmail">
                <Form.Control
                  as="textarea"
                  placeholder="Brief Summary"
                  style={{ height: "150px" }}
                  value={formData.summary.value}
                  name={"summary"}
                  onChange={onChange}
                />{" "}
                {formData.summary.warning ? (
                  <p className="text-danger mt-1 mb-0">Enter summary</p>
                ) : null}
              </Form.Group>
            </Col>
          </Row>
        </div>
      </div>
      <div className="incident-report-form-footer-action">
        <NavLink className="nav-link" to="/standardwithquickreport">
          <Button variant="dark fw-bold h-100" type="button">
            Cancel
          </Button>
        </NavLink>
        <div>
          <Button
            onClick={(e) => validateForm(e)}
            variant="primary"
            type="button"
            className="button_custom fw-bold text-black"
          >
            Continue
          </Button>
        </div>
      </div>
    </Form>
  );
};

export default OnlineQuickPageOne;
